module.exports = __webpack_public_path__ + "img/product_3.086ccab6.png";